import React from 'react';
import './main.less';

import { Link } from 'react-router';
import { connect } from 'react-redux';

import { actions, selectors } from './';

import Table from '../../../shared/new-table/main';
import { renderDefaultTD } from '../../../shared/new-table/renderers';
import table from './table-initial-data';

import wrapMain from '../../wrap-main';
import withCheckPermission from '../../../shared/check-permission-hoc';
import { enum as permissions } from '../../../../../../../enums/admin-permissions';

function ProgramsCategoryList({ intl, rows, check }) {
	return (
		<div>
			{check(permissions.offersCreate) && (
				<div className='programs-navigation'>
					<Link
						className='ui-btn ui-btn-primary'
						to='/programs/categories/editor'
					>
						{intl('Create offer category')}
					</Link>
				</div>
			)}
			<Table
				className='programs-table'
				table={table}
				rows={rows}
				renderTD={createRenderTD(check)}
			/>
		</div>
	);
}

function createRenderTD(check) {
	return function ({ index, column }, props) {
		if (index === 'actions') {
			return (
				<td className={column.className} key={index}>
					<div className='programs-actions'>
						{check(permissions.offersCreate) && (
							<Link
								className='banners-edit-icon'
								to={`/programs/categories/${props.row.id}/editor`}
							/>
						)}
					</div>
				</td>
			);
		}

		return renderDefaultTD({ index, column }, props);
	};
}

function mapStateToProps(state) {
	return {
		rows: selectors.select(state, 'data'),
		isLoading: selectors.select(state, 'isLoading'),
		isError: selectors.select(state, 'isError')
	};
}

export default connect(mapStateToProps, actions.own)(wrapMain(withCheckPermission(ProgramsCategoryList)));


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/programs/category/list/main.js